import { render, staticRenderFns } from "./CreateQuestionnaireBlock.vue?vue&type=template&id=eab1ea6a&scoped=true"
import script from "./CreateQuestionnaireBlock.vue?vue&type=script&lang=js"
export * from "./CreateQuestionnaireBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab1ea6a",
  null
  
)

export default component.exports